/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Carrier_Stage_CreatedInputs */

const vi_carrier_stage_created = /** @type {(inputs: Carrier_Stage_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo vận đơn`)
};

/**

* @param {Carrier_Stage_CreatedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const carrier_stage_created = /** @type {((inputs?: Carrier_Stage_CreatedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Carrier_Stage_CreatedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_carrier_stage_created(inputs)
});